import { render } from "./joinus.vue?vue&type=template&id=254c7b9f&scoped=true"
import script from "./joinus.vue?vue&type=script&lang=js"
export * from "./joinus.vue?vue&type=script&lang=js"

import "./joinus.vue?vue&type=style&index=0&id=254c7b9f&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\vue-ztxinxi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254c7b9f"]])

export default __exports__